export const CREATE_SESSION_FROM_EHR_APPOINTMENT_TOOL =
  'create_session_from_ehr_appointment';
